<template>
  <b-table
    :data="lockerDeliveries"
    hoverable
    @click="openLockerDeliveryDetails"
    style="cursor: pointer"
  >
    <b-table-column
      field="deliveryId"
      :label="$t('lockerDelivery.deliveryId')"
      v-slot="props"
      sortable
    >
      {{ props.row.deliveryId }}
    </b-table-column>

    <b-table-column
      field="client.personalInfo.name"
      :label="$t('lockerDelivery.client')"
      v-slot="props"
      sortable
    >
      {{ props.row.client.personalInfo.name }}
    </b-table-column>

    <b-table-column
      v-if="hasCourier"
      field="courier.personalInfo.name"
      :label="$t('lockerDelivery.courier')"
      v-slot="props"
      sortable
    >
      {{ props.row.client.personalInfo.name }}
    </b-table-column>

    <b-table-column
      field="status"
      :label="$t('lockerDelivery.status')"
      v-slot="props"
      sortable
    >
      {{
        props.row.status === "waitingPackage"
          ? $t("lockerDelivery.waitingPackage")
          : props.row.status === "accessedByCourier"
          ? $t("lockerDelivery.accessedByCourier")
          : props.row.status === "deliveryConfirmed"
          ? $t("lockerDelivery.deliveryConfirmed")
          : props.row.status === "waitingPickUp"
          ? $t("lockerDelivery.waitingPickUp")
          : props.row.status === "accessedByClient"
          ? $t("lockerDelivery.accessedByClient")
          : props.row.status === "pickupConfirmed"
          ? $t("lockerDelivery.pickupConfirmed")
          : props.row.status === "cancelled"
          ? $t("lockerDelivery.cancelled")
          : "-"
      }}
    </b-table-column>

    <template slot="empty">
      <table-empty-template />
    </template>
  </b-table>
</template>

<script>
import tableEmptyTemplate from "../common/TableEmptyTemplate";

export default {
  props: ["lockerDeliveries", "hasCourier"],

  components: {
    tableEmptyTemplate
  },

  methods: {
    openLockerDeliveryDetails(lockerDelivery) {
      this.$emit("open-locker-delivery-details", lockerDelivery);
    }
  }
};
</script>
